import RequestService from "../util/request";
import { environment, getOnlineServices } from "../util";
import { useDispatch, useSelector } from "react-redux";
import { createFailureAction, createSetNetworkAction, createSetNetworkDetails } from "state/reducer";
import { IADPState, NetworkConnectionState, NetworkConnectionStateObj } from "../Types/AppStateTypes";
import { ConnectionType } from "lib/types";

const logPrefix = "[ADPClient][NetworkServiceHook]"

function checkNetworkState(networkConnectionState:NetworkConnectionState){
 if(networkConnectionState === "N/A")return "NoInternetConnectionDetected"
 return undefined

}
export function useNetworkService() {
  const state = useSelector((state:{rootState:IADPState})=>state.rootState);
  const dispatch = useDispatch()
   const {checkOnlineServerAvailability}  = useResolveServiceStatus();
    function initElectronNetworkResolution(){
          console.log("[ADPClient] initElectronNetworkResolution");
            const onNetworkStateChange = (event: any)=>{
            console.log("onNetworkStateChange",event.detail.message[0]);
          if(window.navigator.onLine){
            checkOnlineServerAvailability().then((isServerReachable)=>{
              if(isServerReachable){
                dispatch(createSetNetworkAction("Connected"));
                dispatch(createSetNetworkDetails(event.detail.message[0] as NetworkConnectionStateObj));
              }
            else {
              dispatch(createFailureAction("NoServerConnectionDetected"));
          }
        })
      }
           else {
            dispatch(createSetNetworkAction("N/A"));
            dispatch(createFailureAction("NoInternetConnectionDetected"));
           }
         
            };
            window.addEventListener('network-state-changed', onNetworkStateChange);
            window.addEventListener('network-state-changed-init', async (event)=>{ //@ts-ignore
              console.log("network-state-changed init",event.detail); //@ts-ignore
             dispatch(createSetNetworkAction(event.detail));
            },{once:true});
            return;
        };  
   async function initWebAPINetworkResolution(){
      console.log("[ADPClient] initWebAPINetworkResolution");
      const getConnection =()=>{
        //postMessageToAdpBridge({type:"NetworkDetails"}); TODO implement adp-bridge
        let connectionType:ConnectionType = window.navigator.onLine ? "Connected" : "N/A";
        return connectionType;
      }
      dispatch(createSetNetworkAction(getConnection()));
      //listen on network changes
      window.addEventListener("offline", (e) => {
        console.log(logPrefix,"device is offline");
        dispatch(createSetNetworkAction("N/A"));
      });
      window.addEventListener("online", async (e) => {
        console.log(logPrefix,"device is online");
        dispatch(createSetNetworkAction(getConnection()));
      });
      //network change monitoring
      setInterval(async ()=>{
        const connectionType =  getConnection()
        if(state.sessionState.networkConnectionState === connectionType)return;
        dispatch(createSetNetworkAction(connectionType));
      },20000);
      window.addEventListener('network-state-changed', async (event)=>{
        const connectionType =  getConnection()
        console.log("network-state-changed event",connectionType);
        dispatch(createSetNetworkAction(connectionType)); 
      },{once:true});
      return;
   }     
 function initNetworkResolution(){
  if(navigator.userAgent.includes("Electron")){
    initElectronNetworkResolution()
  }
  else  {
    initWebAPINetworkResolution();
  }

 }

return  {initNetworkResolution,initElectronNetworkResolution,initWebAPINetworkResolution};
};

export function useResolveServiceStatus() {
  const dispatch = useDispatch()
  const state = useSelector((state:{rootState:IADPState})=>state.rootState);
     
 async function checkOnlineServerAvailability ():Promise<boolean>{
   return new Promise(async (resolve) => {
     if(state.sessionState.networkConnectionState === "Connected"){
       console.log("[ADpClient][useNetworkService] Device is online, check if online NAEP services are reachable");
       const onlineURL =`${environment.resolveApiDomain(state.appState.configuration)}/${getOnlineServices(state.appState.configuration)?.cloudServiceHealth}`;
       RequestService.request(onlineURL,'get').then(()=>{
         console.log("Device is online and NAEP services are reachable");
         resolve(true);
       }).catch((e:unknown)=>{
         console.warn("Device is online , however,  Online NAEP services are not reachable",e);
         dispatch(createFailureAction("NoServerConnectionDetected"));
         resolve(false)
       })
     }
     else {
       dispatch(createFailureAction("NoInternetConnectionDetected"));
       resolve(false)
     }
   });
 } ;

 

return {checkOnlineServerAvailability}
};

export {checkNetworkState}

